import axios from "axios";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
    timeout: 30000,
    withCredentials: true,
});

export default api;
